<template>
	<AppIcon :name="loopIconName" />
</template>

<script>
import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'LoopSvg',
	data() {
		return { loopIconName: ServiceSlugs.Loop };
	},
};
</script>

<style scoped lang="scss"></style>
